import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/reconciliation/$statementId',
}).lazy(() => import('./reconciliation.$statementId.index.lazy').then((d) => d.Route))
